import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const Customer360Context = createContext(null);

export const Customer360Provider = ({ children }) => {
  const [customerId, setCustomerId] = useState(null);

  const openCustomer = useCallback((id) => {
    if (id == null || id === "") return;
    const parsed = Number(id);
    if (Number.isNaN(parsed)) return;
    setCustomerId(parsed);
  }, []);

  const closeCustomer = useCallback(() => {
    setCustomerId(null);
  }, []);

  const value = useMemo(
    () => ({
      customerId,
      open: customerId != null,
      openCustomer,
      closeCustomer,
    }),
    [customerId, openCustomer, closeCustomer]
  );

  return (
    <Customer360Context.Provider value={value}>{children}</Customer360Context.Provider>
  );
};

export const useCustomer360 = () => {
  const context = useContext(Customer360Context);
  if (!context) {
    throw new Error("useCustomer360 deve ser usado dentro de Customer360Provider.");
  }
  return context;
};
